import * as React from 'react';
import { observer } from 'mobx-react';
import { RecordedAchBankAccountPaymentMethod } from './payment-entry-model';
import { FormControlLabelled, FormControlType } from '../../../components/form-controls/form-control-labelled';
import { ModelMetadata } from '../../virtual-terminal-generated';
import { injectAnalytics, recordEvent, WithAnalytics } from '../../../analytics';

@injectAnalytics
@observer
export class PaymentMethodRecordedAch extends React.Component<WithAnalytics & {
	achBankAccount: RecordedAchBankAccountPaymentMethod;
}, {}> {
	render() {
		const { achBankAccount: { paymentReference } } = this.props;

		return (
			<div className="vt-payment-method">
				<FormControlLabelled label="Payment reference (optional)"
					formControlProps={{
						formControlType: FormControlType.Text,
						name: ModelMetadata.RecordedACHModel.Reference.propertyName,
						placeholder: 'Enter a payment reference',
						type: 'text',
						value: paymentReference,
						onChangeHandler: this.handlePaymentReferenceChange,
						...(NewFeatures.SetupPinpointAnalytics && { onBlurHandler: this.handlePaymentReferenceBlur }),
						maxLength: this.referenceValidationRules.length.parameters.max,
						validationRules: this.referenceValidationRules,
						acceptanceTestTargetId: 'payment reference - ach - recorded'
					}} />
			</div>
		);
	}

	private handlePaymentReferenceBlur = () => {
		const { analytics, achBankAccount: { paymentReference } } = this.props;
		if (analytics && paymentReference) {
			const { feature, subFeature } = analytics;
			recordEvent({
				feature,
				subFeature,
				eventTypeLabel: 'completePaymentMethod',
				attributes: { paymentMethodType: 'recordedACH' }
			});
		}
	}

	private handlePaymentReferenceChange = (event: React.FormEvent<HTMLInputElement>) => {
		this.props.achBankAccount.updatePaymentReference(event.currentTarget.value);
	}

	private get referenceValidationRules() {
		return ModelMetadata.RecordedACHModel.Reference.validationRules;
	}
}
